import "./GVTSymbol.css";

export const GVTSymbol = (props: {
	children: string;
}) => {
	return (
		<span class="gvt-symbol">
			{props.children}
		</span>
	);
};
